export default [
  {
    name: "font",
    type: "font",
    path: "helvetiker_regular.typeface.json",
  },
  {
    name: "matcapTexture",
    type: "texture",
    path: "textures/creammatcap.png",
  },
  {
    name: "porcelainMatcap",
    type: "texture",
    path: "textures/matcap-porcelain-white.jpg",
  },
  {
    name: "matcapTexture2",
    type: "texture",
    path: "textures/matcapTexture2.jpg",
  },
  {
    name: "sphere1",
    type: "texture",
    path: "textures/sphere1.png",
  },
  {
    name: "sphere2",
    type: "texture",
    path: "textures/sphere2.png",
  },
  {
    name: "sphere3",
    type: "texture",
    path: "textures/sphere3.jpg",
  },
  {
    name: "redRoomFloor",
    type: "texture",
    path: "textures/redRoomFloor.jpg",
  },
  {
    name: "butterflyTexture",
    type: "texture",
    path: "textures/butterfly.png",
  },
];
